import * as React from 'react';

interface StatStripXpress2ConnectionStepsProps {
    onNext: () => void;
}

export const StatStripXpress2ConnectionSteps = ({ onNext }: StatStripXpress2ConnectionStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Connect Device to PC</h2>
                    </div>
                    <div className="col-md-12">
                        <ol className="posh-list">
                            <li>Plug the data cable into the device then connect to a USB port on your PC</li>
                            <li>Ensure the device powers on and displays either 'OK' or 'End'</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onNext}>Next</button>
            </div>
        </>
    );
}
